// React
import React from "react";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./Card.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class Card extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.card }, this.props.children));
    }
}
